<template>
  <nav
    class="sidebar"
    :class="{
      sidebar_expand: expandedMenu && !sideMenuLock,
      sidebar_locked: sideMenuLock,
      sidebar_light: theme.navTheme === 'light',
      sidebar_dark: theme.navTheme === 'dark',
    }"
    @mouseleave="collapseMenu"
    @mouseover="expandMenu"
  >
    <div class="logo_items flex">
      <div class="nav_logo" v-show="!expandedMenu && !sideMenuLock">
        <div
          v-if="
            theme.themeEnabled &&
            ((theme.navTheme == 'light' && theme.logoIcon) ||
              (theme.navTheme == 'dark' && theme.logoIconInverse))
          "
        >
          <img
            :src="theme.logoIcon"
            alt="company logo"
            v-if="theme.navTheme == 'light'"
          />
          <img :src="theme.logoIconInverse" alt="company logo" v-else />
        </div>
        <div v-else>
          <img
            :src="require('@/assets/images/global/logo-symbol.svg')"
            alt="company logo"
            v-if="theme.navTheme == 'light'"
          />
          <img
            :src="require('@/assets/images/global/logo-symbol-inverse.svg')"
            alt="company logo"
            v-else-if="theme.navTheme == 'dark'"
          />
        </div>
      </div>
      <div class="nav_full_logo" v-show="expandedMenu || sideMenuLock">
        <div
          v-if="
            theme.themeEnabled &&
            ((theme.navTheme == 'light' && theme.logoFull) ||
              (theme.navTheme == 'dark' && theme.logoFullInverse))
          "
        >
          <img
            :src="theme.logoFull"
            alt="company logo"
            v-if="theme.navTheme == 'light'"
          />
          <img :src="theme.logoFullInverse" alt="company logo" v-else />
        </div>
        <div v-else>
          <img
            v-if="companyType == 'business' && theme.navTheme == 'light'"
            :src="require('@/assets/images/global/logo-full.svg')"
            alt="company logo"
          />
          <img
            v-if="companyType == 'business' && theme.navTheme == 'dark'"
            :src="require('@/assets/images/global/logo-full-inverse.svg')"
            alt="company logo"
          />
          <img
            v-if="companyType == 'admin'"
            :src="require('@/assets/images/global/logo-admin.svg')"
            alt="company logo"
          />
        </div>
      </div>
      <div
        @click="sideMenuLockToggle()"
        v-show="expandedMenu || sideMenuLock"
        class="sidelock_btn"
      >
        <svg
          v-if="sideMenuLock"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-tooltip="{
            value: $t('global.unlock_sidebar'),
            showDelay: 1500,
            hideDelay: 300,
          }"
          style="width: 20px"
          class="sidebar_highlight"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 0V20H2C0.895432 20 0 19.1046 0 18V2C0 0.895432 0.895432 0 2 0H13Z"
            fill="currentColor"
          />
          <rect
            x="0.75"
            y="0.75"
            width="19.5"
            height="18.5"
            rx="1.25"
            :stroke="theme.navTheme === 'light' ? '#000' : '#fff'"
            stroke-width="1.5"
          />
        </svg>
        <svg
          v-else
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="width: 20px"
          v-tooltip="{
            value: $t('global.lock_sidebar'),
            showDelay: 1500,
            hideDelay: 300,
          }"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.00003 0V20H2C0.895432 20 0 19.1046 0 18V2C0 0.895431 0.89543 0 2 0H9.00003Z"
            fill="#999996"
          />
          <rect
            x="0.75"
            y="0.75"
            width="19.5"
            height="18.5"
            rx="1.25"
            :stroke="theme.navTheme === 'light' ? '#000' : '#fff'"
            stroke-width="1.5"
          />
        </svg>
      </div>
    </div>
    <div class="menu_container">
      <ul
        class="menu_items"
        v-if="companyType == 'business'"
        :class="{
          menu_item_light: theme.navTheme === 'light',
          menu_item_dark: theme.navTheme === 'dark',
        }"
      >
        <!-- Customer Settings -->
        <router-link :to="{ name: 'newsfeed' }">
          <li
            class="menu_item flex"
            :class="[
              $route.name == 'newsfeed'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('newsfeed.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.name === 'newsfeed' && theme.navTheme === 'light',
                }"
              >
                <path
                  d="M9 18.5L12.3945 14.2568C12.7319 13.8351 13.3433 13.7575 13.7754 14.0815L16.2246 15.9185C16.6567 16.2425 17.2681 16.1649 17.6055 15.7432L21 11.5"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
                <rect
                  x="2.5"
                  y="2.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("newsfeed.activity_feed") }}
            </h5>
          </li>
        </router-link>
        <!-- The job marketplace, for general users. Only where the company has
             recruitment on and has not switched the Marketplace off. -->
        <router-link
          :to="{ name: 'user-marketplace' }"
          v-if="userMarketplaceEnabled"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.meta.topLevel == 'user-marketplace'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('recruitment.user_menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.meta.topLevel == 'user-marketplace' &&
                    theme.navTheme === 'light',
                }"
              >
                <path
                  d="M3 13.5V23C3 24.1046 3.89543 25 5 25H25C26.1046 25 27 24.1046 27 23V13.5"
                  stroke="currentColor"
                />
                <path
                  d="M17.59 16.956L25.3083 15.7519C26.282 15.6 27 14.7614 27 13.7758V10C27 8.89543 26.1046 8 25 8H5C3.89543 8 3 8.89543 3 10V13.7758C3 14.7614 3.71796 15.6 4.69173 15.7519L12.6923 17"
                  stroke="currentColor"
                />
                <path
                  d="M20 8V7C20 5.89543 19.1046 5 18 5H12C10.8954 5 10 5.89543 10 7V8"
                  stroke="currentColor"
                />
                <path
                  d="M17.5 15.5V18C17.5 18.2761 17.2761 18.5 17 18.5H13C12.7239 18.5 12.5 18.2761 12.5 18V15.5H17.5Z"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("recruitment.marketplace") }}
            </h5>
          </li>
        </router-link>
        <router-link
          :to="{ name: 'marketplace-job-posts' }"
          v-if="userType == 'customer' && companyFeatures?.enableRecruitment"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.meta.topLevel == 'marketplace'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('recruitment.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.meta.topLevel == 'marketplace' &&
                    theme.navTheme === 'light',
                }"
              >
                <circle cx="13.5" cy="13.5" r="10" stroke="currentColor" />
                <path
                  d="M25.6464 27.3536C25.8417 27.5488 26.1583 27.5488 26.3536 27.3536C26.5488 27.1583 26.5488 26.8417 26.3536 26.6464L26 27L25.6464 27.3536ZM20 21L19.6464 21.3536L25.6464 27.3536L26 27L26.3536 26.6464L20.3536 20.6464L20 21Z"
                  fill="currentColor"
                />
                <circle cx="13.5" cy="9.5" r="3" stroke="currentColor" />
                <path
                  d="M19 19C19 16.2386 16.5376 14 13.5 14C10.4624 14 8 16.2386 8 19"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("recruitment.marketplace") }}
            </h5>
          </li>
        </router-link>
        <router-link
          :to="{ name: 'onboarding' }"
          v-if="userType == 'customer' && companyFeatures?.enableRecruitment"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.meta.topLevel == 'onboarding'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('onboarding.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.meta.topLevel == 'onboarding' &&
                    theme.navTheme === 'light',
                }"
              >
                <path
                  d="M25.2922 18.051L25.9482 18.696C26.4402 19.3411 27.129 20.8246 25.9482 21.5986C24.9191 22.2732 24.2088 22.1639 23.3728 21.5986C23.0098 21.3532 22.623 21.0217 22.1761 20.6311C20.9953 19.5991 18.1854 16.761 16.928 15.4709M14.4679 17.8898C15.616 18.911 17.5 21 18.896 22.0824C19.2499 22.4883 19.6038 22.8108 19.9729 23.0499C20.6302 23.4757 21.5 24 22.5 23.5C23.4459 23.0271 23.4113 22.1899 23.3728 21.5986M19.9729 23.0499C20.1606 23.5874 19.9729 24.5 19.388 25.1462C18.8032 25.7925 17.7808 25.8558 16.6 24.8237M16.6 24.8237C15.4192 23.7917 12.9372 21.3836 11.8439 20.3086M16.6 24.8237C16.6 25.4688 16.6 26.5 15.288 26.9201C14.029 27.3231 13.2543 26.8878 12.3359 26.1138C11.4175 25.3398 5.5024 19.4486 2.65967 16.5997C1.18364 14.8797 -0.6532 10.4075 3.8077 6.27936C8.2686 2.15122 12.7732 4.5593 14.4679 6.27936M14.4679 6.27936C16.6 4.77431 21.6681 2.64343 25.2922 5.79559C28.2576 8.37488 30.5 11.5 27.5882 16.1159C25.9482 17.8898 25.5108 17.8897 25.2922 18.051M14.4679 6.27936L11.8439 8.85944C10.8598 10 9.64016 11.4677 10.5 12.4071C11.6808 13.6971 13.2106 12.8371 13.6479 12.4071L16.6 9.50447L25.2922 18.051"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("onboarding.onboarding") }}
            </h5>
          </li>
        </router-link>
        <router-link
          :to="{ name: userType == 'customer' ? 'topics' : 'content' }"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.name == 'topics' || $route.name == 'content'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('content.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    ($route.name == 'topics' || $route.name == 'content') &&
                    theme.navTheme === 'light',
                }"
              >
                <path
                  d="M5 15H20"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M5 19L15 19"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M22.3302 1H3.66975C2.19529 1 1 2.19529 1 3.66975V22.3302C1 23.8047 2.19529 25 3.66975 25H22.3302C23.8047 25 25 23.8047 25 22.3302V3.66975C25 2.19529 23.8047 1 22.3302 1Z"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                />
                <path
                  d="M29 15V23.9848C29 26.7548 26.7562 29 23.9878 29H15"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M21.25 8.93301L16 11.9641C15.6667 12.1566 15.25 11.916 15.25 11.5311L15.25 5.46891C15.25 5.08401 15.6667 4.84345 16 5.0359L21.25 8.06699C21.5833 8.25944 21.5833 8.74056 21.25 8.93301Z"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("content.library") }}
            </h5>
          </li>
        </router-link>
        <router-link
          :to="{ name: userType == 'customer' ? 'training-people' : 'courses' }"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.meta.topLevel == 'training' || $route.name == 'courses'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('training.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <div class="icon_badge" v-if="requiredActions.length > 0"></div>
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    ($route.meta.topLevel == 'training' ||
                      $route.name == 'courses') &&
                    theme.navTheme === 'light',
                }"
              >
                <path
                  d="M4 14V19C4 21.7614 6.23858 24 9 24H21C23.7614 24 26 21.7614 26 19V14"
                  stroke="currentColor"
                />
                <path
                  d="M1.72662 9.93394L14.4852 2.58636C14.9486 2.31951 15.519 2.31951 15.9824 2.58636L28.741 9.93394C29.7429 10.5109 29.7429 11.9567 28.741 12.5337L15.9824 19.8812C15.519 20.1481 14.9486 20.1481 14.4852 19.8812L1.72662 12.5337C0.72472 11.9567 0.72472 10.5109 1.72662 9.93394Z"
                  stroke="currentColor"
                />
                <path d="M16 11L23 16.0744V28" stroke="currentColor" />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("training.training") }}
            </h5>
          </li>
        </router-link>
        <router-link :to="{ name: 'challenges' }" v-if="userType == 'customer'">
          <li
            class="menu_item flex"
            :class="[
              $route.name == 'challenges'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('challenges.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.name == 'challenges' && theme.navTheme === 'light',
                }"
              >
                <path
                  d="M4.05455 27L9.65455 17.8085L14.2364 21.383L19.8364 12.1915M19.8364 12.1915L26.9636 27M19.8364 12.1915V7.59574M1 27H29M19.8364 7.59574V3H26.9636V7.59574H19.8364Z"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("challenges.challenges") }}
            </h5>
          </li>
        </router-link>
        <!-- <router-link :to="{name: 'goal-posts'}">
                    <li class="menu_item flex" :class="{menu_item_active: $route.name == 'goal-posts', menu_item_hover: $route.name != 'goal-posts'}" v-tooltip="{ value: $t('goal_posts.menu_tooltip'), showDelay: 800, hideDelay: 300 }">
                        <div class="menu_icon">
                            <img :src="require('@/assets/icons/icon-goal-posts.svg')" :class="{icon_highlight: $route.name == 'goal-posts'}" style="width: 30px; margin: 5px" />
                        </div>
                        <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
                            {{ $t('goal_posts.goal_posts') }}
                        </h5>
                    </li>
                </router-link> -->
        <router-link :to="{ name: 'forms' }" v-if="userType == 'customer'">
          <li
            class="menu_item flex"
            :class="[
              $route.name == 'forms'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('forms.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.name == 'forms' && theme.navTheme === 'light',
                }"
              >
                <rect
                  x="2.5"
                  y="3.5"
                  width="25"
                  height="10"
                  rx="2.5"
                  stroke="currentColor"
                />
                <rect
                  x="2.5"
                  y="16.5"
                  width="25"
                  height="10"
                  rx="2.5"
                  stroke="currentColor"
                />
                <path
                  d="M16 8L24 8"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
                <path
                  d="M16 21L24 21"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
                <path
                  d="M6 8.28571L7.5 10L11 6"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
                <circle cx="8.5" cy="21.5" r="2" stroke="currentColor" />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("forms.forms") }}
            </h5>
          </li>
        </router-link>
        <router-link
          :to="{ name: 'reward-items' }"
          v-if="userType == 'customer'"
        >
          <li
            class="menu_item flex"
            :class="[
              $route.meta.topLevel == 'rewards'
                ? theme.navTheme === 'light'
                  ? 'menu_item_active_light'
                  : 'menu_item_active_dark'
                : theme.navTheme === 'light'
                ? 'menu_item_hover_light'
                : 'menu_item_hover_dark',
            ]"
            v-tooltip="{
              value: $t('points.menu_tooltip'),
              showDelay: 800,
              hideDelay: 300,
            }"
          >
            <div class="menu_icon">
              <div class="icon_badge" v-if="pendingClaims > 0"></div>
              <svg
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                  icon_light: theme.navTheme === 'light',
                  icon_dark: theme.navTheme !== 'light',
                  icon_highlight:
                    $route.meta.topLevel == 'rewards' &&
                    theme.navTheme === 'light',
                }"
              >
                <circle cx="15" cy="15" r="14.5" stroke="currentColor" />
                <path
                  d="M15.4755 7.08156L16.7696 11.0643C16.9704 11.6824 17.5464 12.1008 18.1962 12.1008H22.3839C22.8683 12.1008 23.0697 12.7206 22.6778 13.0053L19.2899 15.4668C18.7641 15.8488 18.5442 16.5258 18.745 17.1439L20.0391 21.1266C20.1887 21.5873 19.6615 21.9704 19.2696 21.6857L15.8817 19.2242C15.3559 18.8422 14.6441 18.8422 14.1183 19.2242L10.7304 21.6857C10.3385 21.9704 9.81127 21.5873 9.96095 21.1266L11.255 17.1439C11.4558 16.5258 11.2359 15.8488 10.7101 15.4668L7.32217 13.0053C6.93031 12.7206 7.1317 12.1008 7.61606 12.1008H11.8038C12.4536 12.1008 13.0296 11.6824 13.2304 11.0643L14.5245 7.08156C14.6741 6.6209 15.3259 6.6209 15.4755 7.08156Z"
                  stroke="currentColor"
                />
              </svg>
            </div>
            <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
              {{ $t("points.rewards") }}
            </h5>
          </li>
        </router-link>
      </ul>
      <!-- Admin Settings -->
      <ul class="menu_items" v-if="companyType == 'admin'">
        <li
          class="menu_item flex"
          :class="[
            $route.meta.topLevel == 'accounts'
              ? theme.navTheme === 'light'
                ? 'menu_item_active_light'
                : 'menu_item_active_dark'
              : theme.navTheme === 'light'
              ? 'menu_item_hover_light'
              : 'menu_item_hover_dark',
          ]"
          @click="expandedAccounts = !expandedAccounts"
          v-tooltip.right="{
            value: $t('admin.accounts_tooltip'),
            showDelay: 300,
            hideDelay: 300,
          }"
        >
          <div class="menu_icon">
            <svg
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="{
                icon_light: theme.navTheme === 'light',
                icon_dark: theme.navTheme !== 'light',
                icon_highlight:
                  $route.meta.topLevel == 'accounts' &&
                  theme.navTheme === 'light',
              }"
            >
              <path
                d="M21.9514 28.5101H7.9313C7.75532 28.4754 7.57934 28.4401 7.40283 28.4069C5.42263 28.0357 4.04088 26.606 3.87691 24.6293C3.80067 23.7083 3.84819 22.7677 3.93279 21.8446C4.07117 20.3357 4.4153 18.8713 5.16153 17.5246C5.98818 16.0332 7.21118 15.0977 8.93184 14.8628C9.42167 14.7959 9.91724 14.7384 10.3705 15.034C10.7768 15.2989 11.1883 15.5556 11.6014 15.8087C13.8332 17.1771 16.0662 17.1761 18.2965 15.8035C18.6798 15.5675 19.0475 15.3041 19.4422 15.0889C19.6798 14.9593 19.955 14.8234 20.2146 14.8208C21.3942 14.8099 22.4789 15.1346 23.4 15.8922C24.4549 16.7602 25.0439 17.9264 25.4361 19.1954C25.9479 20.8501 26.1108 22.5535 26.0659 24.2793C26.0168 26.1715 24.8549 27.7059 23.0334 28.2664C22.6809 28.3748 22.3128 28.4303 21.9514 28.5101Z"
                stroke="currentColor"
                stroke-miterlimit="10"
              />
              <path
                d="M21.2072 8.42344C21.202 11.9885 18.2092 14.7991 14.7502 14.7799C11.1402 14.7602 8.29051 11.7609 8.34325 8.29224C8.39651 4.81119 11.3527 1.95136 14.8692 2.00063C18.3351 2.04937 21.2474 4.92216 21.2072 8.42344Z"
                stroke="currentColor"
                stroke-miterlimit="10"
              />
            </svg>
          </div>
          <h5 class="menu_title" v-show="expandedMenu || sideMenuLock">
            {{ $t("global.accounts") }}
          </h5>
        </li>
        <ul
          class="sub_menu_items"
          v-show="
            (expandedAccounts && expandedMenu) ||
            (sideMenuLock && expandedAccounts)
          "
        >
          <router-link :to="{ name: 'admin-accounts' }">
            <li
              class="sub_menu_item"
              v-tooltip.right="{
                value: $t('admin.companies_tooltip'),
                showDelay: 300,
                hideDelay: 300,
              }"
            >
              {{ $t("admin.companies") }}
            </li>
          </router-link>
          <router-link :to="{ name: 'admin-users' }">
            <li
              class="sub_menu_item"
              v-tooltip.right="{
                value: $t('admin.users_tooltip'),
                showDelay: 300,
                hideDelay: 300,
              }"
            >
              {{ $t("profile.users") }}
            </li>
          </router-link>
        </ul>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      expandedMenu: false,
      expandedAccounts: false,
    };
  },
  computed: {
    // General users only, and only where the company has recruitment on and
    // the Marketplace itself enabled (it defaults to on).
    userMarketplaceEnabled() {
      return (
        this.userType == "general" &&
        this.companyFeatures?.enableRecruitment === true &&
        this.companyRecruitment?.marketplaceEnabled !== false
      );
    },
    ...mapGetters("userData", [
      "companyDetails",
      "companyFeatures",
      "companyRecruitment",
      "sideMenuLock",
      "userLoaded",
      "companyLoaded",
      "companyType",
      "userType",
      "theme",
    ]),
    ...mapGetters("marketplaceData", ["actionsRequired"]),
    ...mapGetters("trainingManagement", ["requiredActions"]),
    ...mapGetters("rewardsManagement", ["pendingClaims"]),
  },
  methods: {
    // Sets menu settings for collapsed view
    collapseMenu() {
      if (!this.sideMenuLock) {
        this.expandedMenu = false;
        this.expandedAccounts = false;
      }
    },
    // Sets menu settings for expanded view
    expandMenu() {
      if (!this.sideMenuLock) {
        this.expandedMenu = true;
      }
    },
    ...mapActions("userData", ["sideMenuLockToggle"]),
  },
  created() {
    //Being the first element loaded in the application - checck if user details are available
    if (!this.userLoaded || !this.companyLoaded) {
      this.$router.push("callback");
    }
  },
};
</script>

<style scoped>
body {
  min-height: 65vh;
}

/* Pre CSS */

.logo_items {
  gap: 5px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--light-active);
}

.nav_logo img,
.nav_full_logo img {
  height: 30px;
}

.nav_logo,
.nav_full_logo {
  width: 100%;
  height: 30px;
  margin-left: 13px;
  margin-top: 5px;
}

.sidelock_btn {
  cursor: pointer;
}

/* Sidebar */

.sidebar {
  position: fixed;
  width: 70px;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100%;
  padding: 15px 10px;
  transition: all 0.5s ease;
}

.sidebar_light {
  background-color: var(--light);
}

.sidebar_dark {
  background-color: var(--dark);
}

.sidebar a {
  color: #000;
  text-decoration: none;
}

.menu_container {
  overflow-y: auto;
  height: calc(100% - 35px);
}

.menu_container ul {
  padding: 0px;
}

.menu_item {
  padding: 0px;
  margin-bottom: 5px;
  border-radius: var(--border-radius);
  width: 100%;
  cursor: pointer;
}

.menu_item_light a {
  color: #000;
}

.menu_item_dark a {
  color: #fff;
}

.menu_item_active_light {
  background: var(--dark);
  color: #fff;
}

.menu_item_active_dark {
  background: var(--highlight);
  color: #fff;
}

.menu_item_hover_light:hover {
  background: var(--light-active);
  color: #000;
}

.menu_item_hover_dark:hover {
  background: var(--dark-active);
  color: #fff;
}

.sub_menu_items {
  background: var(--light-active);
  border-radius: var(--border-radius);
  margin-bottom: 10px;
}

.sub_menu_item {
  padding: 10px;
  border-radius: var(--border-radius);
  cursor: pointer;
}

.sub_menu_item:hover {
  background: #fff;
}

.menu_icon {
  padding: 5px 5px;
  border-radius: var(--border-radius);
  display: inline-block;
}

.menu_title {
  display: inline-block;
  white-space: nowrap;
  margin: 0px;
  padding-left: 3px;
  transition: all 0.3s ease;
}

.icon_light {
  color: var(--dark);
  width: 30px;
  margin-left: 5px;
  margin-top: 5px;
}

.icon_dark {
  color: #fff;
  width: 30px;
  margin-left: 5px;
  margin-top: 5px;
}

.icon_highlight {
  color: #fff;
}

.sidebar_highlight {
  color: var(--highlight);
}

.icon_badge {
  position: absolute;
  left: 46px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: red;
}

/* Expand and Collapse */

.sidebar_collapse {
  width: 70px;
}

.sidebar_expand {
  width: 240px;
  box-shadow: 0 0 20px grey;
}

.sidebar_locked {
  width: 240px;
}

/* Responsive */
@media screen and (max-width: 500px) {
  .sidebar {
    display: none;
  }

  .sidebar_locked {
    display: block !important;
    width: 80%;
    display: block;
    box-shadow: 0 0 20px grey;
  }
}
</style>
